import {Avatar, Grid} from '@mui/material';

import {MatchLevel} from '../MatchLevel';

import {MiniCultureType} from './CultureFitHeader';
import {CultureTypeCard} from '../../../../../../components/CultureTypeCard/CultureTypeCard';
import {applicantMatchText} from '../../../../../../lib/constants';
import {extractPercentAsNumber} from '../../../../../../utils/extractPercentAsNumber';

interface Props {
  companyLogoUrl: string;
  companyCultureType: MiniCultureType;
  applicantAvatarUrl: string;
  applicantCultureType: MiniCultureType | null;
  culturalFitScore: string;
}

const AVATAR_OVERLAY_OFFSET = 40;
const MAX_CULTURE_CARD_WIDTH = 392;
export const DesktopDisplay = ({
  companyLogoUrl,
  applicantAvatarUrl,
  applicantCultureType,
  companyCultureType,
  culturalFitScore,
}: Props) => {
  return (
    <Grid container justifyContent='space-between' alignContent='stretch'>
      <Grid
        item
        display='flex'
        width={MAX_CULTURE_CARD_WIDTH}
        overflow='visible'
        alignItems='center'
        justifyContent='flex-start'
      >
        <CultureTypeCard
          minWidth='352px'
          name={companyCultureType.name}
          imageSize='207px'
          url={companyCultureType.url}
          shouldDisplayEmpionLogo={false}
        />
        <Avatar
          src={companyLogoUrl}
          variant='square'
          sx={{width: '80px', height: '80px', left: -AVATAR_OVERLAY_OFFSET}}
        />
      </Grid>
      <Grid
        item
        position='relative'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        maxWidth='368px'
        flexGrow={1}
      >
        <Grid
          item
          container
          flexDirection='column'
          height='50%'
          marginBottom={`${AVATAR_OVERLAY_OFFSET}px`}
          alignItems='flex-end'
          paddingX='16px'
        >
          <MatchLevel
            percent={extractPercentAsNumber(culturalFitScore)}
            isCultureTypeMissing={!applicantCultureType}
            matchText={applicantMatchText}
          />
        </Grid>
      </Grid>
      <Grid
        item
        display='flex'
        overflow='visible'
        alignItems='center'
        justifyContent='flex-start'
        width={MAX_CULTURE_CARD_WIDTH}
      >
        <Avatar src={applicantAvatarUrl} variant='square' sx={{width: '80px', height: '80px', zIndex: 1}} />
        <CultureTypeCard
          minWidth='352px'
          name={applicantCultureType?.name}
          imageSize='207px'
          url={applicantCultureType?.url}
          shouldDisplayEmpionLogo={false}
          sx={{left: -AVATAR_OVERLAY_OFFSET, position: 'relative'}}
        />
      </Grid>
    </Grid>
  );
};
